import { getNextPagePath } from '@department-of-veterans-affairs/platform-forms-system/routing';

/** @param {string} inquiryId Also known as "reference number" or "inquiry number" */
export const getConversationLink = inquiryId => `/inbox/${inquiryId}`;

/**
 * Returns the path of the next page in the form, or the second page if no pathname is provided.
 * @param {string} pathname - The current page path
 * @param {Array<{path: string}>} pageList - The list of pages in the form
 * @param {object} [data={}] - The form data
 * @returns {string} The path of the next page
 */
export const getStartPageLink = (pathname, pageList, data = {}) => {
  const startPagePath = pathname
    ? getNextPagePath(pageList, data, pathname)
    : pageList[1].path;
  return startPagePath.startsWith('/')
    ? startPagePath.substring(1)
    : startPagePath;
};
